<template>
  <b-modal
    id="Formula3"
    size="lg"
    ok-only
  >
    <b-row>
      <span style="margin-left:15px"> <h2>ข้อมูลการคำนวน {{ title }} </h2></span>
    </b-row>
    <b-row class="mb-1">
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />

          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 0C5.8318 0 0 5.8318 0 13C0 20.1682 5.8318 26 13 26C20.1682 26 26 20.1682 26 13C26 5.8318 20.1682 0 13 0ZM17.2809 19.1191L11.7 13.5382V5.2H14.3V12.4618L19.1191 17.2809L17.2809 19.1191V19.1191Z"
                fill="url(#paint0_linear_751_16398)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16398"
                  x1="13"
                  y1="0"
                  x2="13"
                  y2="26"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.458333"
                    stop-color="#F2994A"
                  />
                  <stop
                    offset="1"
                    stop-color="#CF6608"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Peak Hour Factor</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="40"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b> {{ phf }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <!-- Lane Density -->
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 4V28H28"
                stroke="#BB6BD9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59998 24.4C7.59998 24.4 10.7875 4 17.8 4C24.8125 4 28 24.4 28 24.4"
                stroke="#BB6BD9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59998 16H28"
                stroke="#BB6BD9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="2 4"
              />
            </svg>

          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Average Speed</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ as }} </b>
              <strong style="font-size: 20px;">กม./ชม.</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <!-- Free Flow Speed -->
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="10.427"
                y="23.7705"
                width="11.5617"
                height="2.07644"
                rx="1"
                fill="url(#paint0_linear_751_16440)"
              />
              <rect
                x="8.5"
                y="27.9233"
                width="15.4156"
                height="2.07644"
                rx="1"
                fill="url(#paint1_linear_751_16440)"
              />
              <path
                d="M15.6433 17.9194C16.3958 17.1085 23.1374 12.7805 23.1374 12.7805C23.1374 12.7805 19.1209 20.0451 18.3684 20.856C17.6159 21.6669 16.3958 21.6669 15.6433 20.856C14.8908 20.0451 14.8908 18.7303 15.6433 17.9194Z"
                fill="url(#paint2_linear_751_16440)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.58928 10.3665C5.18764 5.63296 9.96281 2.35451 15.5 2V6.75901C11.2214 7.14412 7.61751 9.97683 5.99411 13.9014L2.58928 10.3665ZM25.6166 11.4229C23.7188 8.82112 20.8115 7.05698 17.5 6.75899V2C22.2573 2.30458 26.4522 4.76748 29.1873 8.45715L25.6166 11.4229ZM27.0382 13.9797C27.6117 15.3943 27.9287 16.9485 27.9287 18.5796C27.9287 21.8134 26.6826 24.7451 24.6618 26.8853H30.3595C31.7209 24.442 32.5 21.6052 32.5 18.5796C32.5 15.8219 31.8528 13.2212 30.7074 10.9322L27.0382 13.9797ZM0.5 18.5796C0.5 21.6052 1.27915 24.442 2.64049 26.8853H8.33844C6.3176 24.7451 5.07153 21.8134 5.07153 18.5796C5.07153 17.7931 5.14524 17.0245 5.28586 16.2808L1.61645 12.4711C0.89593 14.3619 0.5 16.4227 0.5 18.5796Z"
                fill="url(#paint3_linear_751_16440)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16440"
                  x1="16.2079"
                  y1="23.7705"
                  x2="16.2079"
                  y2="25.8469"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFD331" />
                  <stop
                    offset="0.8125"
                    stop-color="#FFEBA2"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16440"
                  x1="16.2078"
                  y1="27.9233"
                  x2="16.2078"
                  y2="29.9998"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFD331" />
                  <stop
                    offset="0.8125"
                    stop-color="#FFEBA2"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16440"
                  x1="22"
                  y1="13.9078"
                  x2="13.9628"
                  y2="21.0936"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFEBA1" />
                  <stop
                    offset="0.854167"
                    stop-color="#FFD331"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_751_16440"
                  x1="16.5"
                  y1="2"
                  x2="16.5"
                  y2="26.8853"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFEBA1" />
                  <stop
                    offset="0.666667"
                    stop-color="#FFD331"
                  />
                </linearGradient>
              </defs>
            </svg>

          </foreignObject>
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Free Flow Speed</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ ffs }} </b>
              <strong style="font-size: 20px;">กม./ชม.</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <!-- Average Speed -->
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7041 12.8287V9.38321H6.60001V5.4455H20.7041V2L26.4 7.41435L20.7041 12.8287Z"
                fill="url(#paint0_linear_751_16374)"
              />
              <rect
                x="5.5"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint1_linear_751_16374)"
              />
              <rect
                x="13.2"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint2_linear_751_16374)"
              />
              <rect
                x="20.9"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint3_linear_751_16374)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16374"
                  x1="26.4"
                  y1="7.41435"
                  x2="7.7"
                  y2="7.41435"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16374"
                  x1="8.8"
                  y1="14.8398"
                  x2="8.8"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16374"
                  x1="16.5"
                  y1="14.8398"
                  x2="16.5"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_751_16374"
                  x1="24.2"
                  y1="14.8398"
                  x2="24.2"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Average Annual Daily Traffic (AADT)</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ aadt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} </b>
              <strong style="font-size: 20px;">คัน/วัน</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <!-- Free Flow Speed -->
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="15"
            y="15"
            width="100%"
            height="100%"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count4.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>85th Percentile Speed</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ speed85 }} </b>
              <strong style="font-size: 20px;">กม./ชม.</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="8"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7041 12.8287V9.38321H6.60001V5.4455H20.7041V2L26.4 7.41435L20.7041 12.8287Z"
                fill="url(#paint0_linear_751_16374)"
              />
              <rect
                x="5.5"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint1_linear_751_16374)"
              />
              <rect
                x="13.2"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint2_linear_751_16374)"
              />
              <rect
                x="20.9"
                y="14.8398"
                width="6.6"
                height="15.1602"
                rx="1"
                fill="url(#paint3_linear_751_16374)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16374"
                  x1="26.4"
                  y1="7.41435"
                  x2="7.7"
                  y2="7.41435"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16374"
                  x1="8.8"
                  y1="14.8398"
                  x2="8.8"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16374"
                  x1="16.5"
                  y1="14.8398"
                  x2="16.5"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_751_16374"
                  x1="24.2"
                  y1="14.8398"
                  x2="24.2"
                  y2="30"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF9E9E" />
                  <stop
                    offset="1"
                    stop-color="#EF6D6D"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="40"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Vehicle Kilometer Travel (VKT)</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="50"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ vkt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} </b>
              <strong style="font-size: 20px;">คัน X กม.</strong>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row
      v-if="dl1 !== 0 & dl2 !== 0 & dl3 !== 0 & dl4 !== 0"
      class="mb-1"
    >
      <b-col
        cols="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />

          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 1</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl1 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        cols="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 2</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl2 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        cols="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 3</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl3 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        cols="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 4</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl4 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row
      v-if="dl1 !== 0 & dl2 === 0 & dl3 === 0 & dl4 === 0"
      class="mb-1"
    >
      <b-col
        cols="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="63"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Lane Density 1</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="62"
            y="70"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ dl1 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row
      v-if="dl1 !== 0 & dl2 !== 0 & dl3 === 0 & dl4 === 0"
      class="mb-1"
    >
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Lane Density 1</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="120"
            y="70"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ dl1 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col cols="6">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 136L1 123.179V8.55245H318.693L331.5 1H357V8.55245V123.179L341.5 136H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 1H328.5L317.5 7.03352H313.5L324.5 1Z"
            fill="#00B058"
          />
          <path
            d="M317.5 1H321.5L310.5 7.03352H306.5L317.5 1Z"
            fill="#00B058"
          />
          <path
            d="M310.5 1H314.5L303.5 7.03352H299.5L310.5 1Z"
            fill="#00B058"
          />
          <path
            d="M303.5 1H307.5L296.5 7.03352H292.5L303.5 1Z"
            fill="#00B058"
          />
          <path
            d="M296.5 1H300.5L289.5 7.03352H285.5L296.5 1Z"
            fill="#00B058"
          />
          <path
            d="M289.5 1H293.5L282.5 7.03352H278.5L289.5 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Lane Density 2</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="120"
            y="70"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ dl2 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row
      v-if="dl1 !== 0 & dl2 !== 0 & dl3 !== 0 & dl4 === 0"
      class="mb-1"
    >
      <b-col
        cols="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />

          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 1</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl1 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        cols="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 2</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl2 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        cols="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 326 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1067 262L1 237.212V15.6014H290.136L301.792 1H325V15.6014V237.212L310.893 262H15.1067Z"
            stroke="#00B058"
          />
          <path
            d="M295.421 1H299.062L289.051 12.6648H285.41L295.421 1Z"
            fill="#00B058"
          />
          <path
            d="M289.051 1H292.691L282.68 12.6648H279.039L289.051 1Z"
            fill="#00B058"
          />
          <path
            d="M282.68 1H286.32L276.309 12.6648H272.669L282.68 1Z"
            fill="#00B058"
          />
          <path
            d="M276.309 1H279.949L269.938 12.6648H266.298L276.309 1Z"
            fill="#00B058"
          />
          <path
            d="M269.938 1H273.579L263.567 12.6648H259.927L269.938 1Z"
            fill="#00B058"
          />
          <path
            d="M263.567 1H267.208L257.197 12.6648H253.556L263.567 1Z"
            fill="#00B058"
          />
          <foreignObject
            x="9"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 29 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.375 29L4.875 1"
                stroke="url(#paint0_linear_751_16415)"
                stroke-width="2"
              />
              <path
                d="M27.625 29L24.125 1"
                stroke="url(#paint1_linear_751_16415)"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                fill="url(#paint2_linear_751_16415)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16415"
                  x1="3.125"
                  y1="1"
                  x2="3.125"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.515625"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_751_16415"
                  x1="25.875"
                  y1="1"
                  x2="25.875"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.614583"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_751_16415"
                  x1="14.5"
                  y1="1"
                  x2="14.5"
                  y2="29"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E7E7E7" />
                  <stop
                    offset="0.666667"
                    stop-color="#A3A3A3"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="34"
          >
            <div>
              <strong>Lane Density 3</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="90"
            y="120"
            width="300"
            height="150"
            color="#ffffff"
            font-size="50"
          >
            <div>
              <b> {{ dl3 }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <!-- <b-row class="mb-1">

    </b-row> -->
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BImg, BModal,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BModal,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    title: String,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      formula: [],
      phf: 0,
      ffs: 0,
      as: 0,
      aadt: 0,
      vkt: 0,
      speed85: 0,
      dl1: 0,
      dl2: 0,
      dl3: 0,
      dl4: 0,
    }
  },
  methods: {
    getFormulaPopup3(value) {
      axios
        .post('/getFormulaPopup', { camid: value, wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.formula = response.data[0]
          this.phf = this.formula.PHF
          this.ld = this.formula.DensityLane_Total_Avg
          this.ffs = this.formula.FreeFlowSpeed
          this.as = this.formula.SpeedAVG
          this.aadt = this.formula.AADT
          this.vkt = this.formula.VKT
          this.speed85 = this.formula.Speed85
          this.dl1 = this.formula.DensityLane1
          this.dl2 = this.formula.DensityLane2
          this.dl3 = this.formula.DensityLane3
          this.dl4 = this.formula.DensityLane4
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  </style>
